<template>
  <div class="mt-3">
    <span>{{ $t('preview.relateds.groupers.tagsMore') }}</span>
    <nuxt-link
      v-if="data.length > 0"
      class="exp-font"
      :to="buildUrl(data[0]['slug'])"
      @click.native="$bvModal.hide('preview-vector-modal')"
      >{{ data[0]['name'] }}</nuxt-link
    >
    <span v-if="data.length > 1"> & </span>
    <nuxt-link
      v-if="data.length > 1"
      class="exp-font"
      :to="buildUrl(data[1]['slug'])"
      @click.native="$bvModal.hide('preview-vector-modal')"
      >{{ data[1]['name'] }}</nuxt-link
    >
    <span>{{ $t('preview.relateds.groupers.tagsDesigns') }}</span>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  methods: {
    buildUrl(tag) {
      return this.$urlBuilder('search', { path: 'graphics', keyword: tag });
    }
  }
};
</script>
